import 'xp-lib-brand/index'; // import xp-lib-brand js first

import { toggleMobileMenu } from './header';
import { toggleAccordion } from './accordion-custom';

if (document.readyState !== 'loading') {
   initJavaScript();
} else {
   document.addEventListener('DOMContentLoaded', initJavaScript);
}

function initJavaScript() {
   document.querySelectorAll('.icon--hamburger').forEach(toggleMobileMenu);
   document.querySelectorAll('.event_accordion_title').forEach(toggleAccordion);
}
